<template>
  <BasicExtended v-bind="allProps" />
</template>

<script>
import Basic from '../../ADDITIONAL_HOST/components/basic.vue';
import mixin from '../mixin';
import { planTypes } from '@/common/constants';

const BasicExtended = {
  extends: Basic,
  key: planTypes[planTypes.ADDITIONAL_CO_EDITOR],
};
if (Basic?.__scopeId) {
  BasicExtended.__scopeId = Basic.__scopeId;
}

export default {
  name: 'AdditionalCoEditorConfig',
  components: {
    BasicExtended,
  },
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [mixin],
  computed: {
    // Merge attrs, data, and props for complete prop forwarding
    // Order: attrs -> data -> props (props has highest priority)
    allProps() {
      return {
        ...this.$attrs,
        ...this.$data,
        ...this.$props,
      };
    }
  }
};
</script>
